var or_forms_service =
webpackJsonpor_forms_service([13,1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(24);
	module.exports = __webpack_require__(303);


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(28);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(50);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _getIterator2 = __webpack_require__(33);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.extendObj = extendObj;
	exports.fill = fill;
	exports.range = range;
	exports.formatDateForSubmit = formatDateForSubmit;
	exports.zeroPadNumber = zeroPadNumber;
	exports.mobileScrollToTop = mobileScrollToTop;
	exports.scrollIntoView = scrollIntoView;
	exports.getCurrentScript = getCurrentScript;
	exports.dateToUnix = dateToUnix;
	exports.dateFromUnix = dateFromUnix;
	exports.getOrientation = getOrientation;
	exports.parseErrorObj = parseErrorObj;
	exports.arrayHasArray = arrayHasArray;
	exports.redirectPost = redirectPost;
	exports.validateSSN = validateSSN;
	exports.validateSsnInput = validateSsnInput;
	exports.fixMeterDecimals = fixMeterDecimals;
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extendObj(obj, src) {
	  for (var key in src) {
	    if (src.hasOwnProperty(key)) obj[key] = src[key];
	  }
	  return obj;
	}
	
	function fill(fill, size) {
	  var str = '';
	  for (var i = 0; i < size; i++) {
	    str += fill;
	  }
	  return str;
	}
	
	function range(start, end, step) {
	  var list = [];
	  step = !step ? 1 : 0;
	  for (var i = start; i <= start + end; i += step) {
	    list.push(i);
	  }
	  return list;
	}
	
	function formatDateForSubmit(value) {
	  return '/Date(' + value + '+0000)/';
	}
	
	function zeroPadNumber(value, desiredLength) {
	  var valueStr = value.toString();
	  var valueFloat = parseFloat(valueStr.replace(',', '.').replace(' ', ''));
	  var lengthOfReading = valueFloat.toString().length;
	  var formatLength = parseInt(desiredLength, 10);
	  var difference = formatLength - lengthOfReading;
	  var padString = '';
	  if (difference > 0) {
	    for (var i = 0; i < difference; i++) {
	      padString = '0' + padString;
	    }
	  }
	  return padString + valueFloat;
	}
	
	function mobileScrollToTop() {
	  if (window.innerWidth < 601) {
	    window.scrollTo(0, 0);
	  } else {
	    var appdiv = document.getElementById('app');
	    this.scrollIntoView(appdiv);
	  }
	}
	
	function scrollIntoView(element) {
	  element.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest' });
	}
	
	function getCurrentScript(id) {
	  if (id) {
	    return document.getElementById(id);
	  } else {
	    var scripts = document.querySelectorAll('script[data-lang]');
	    return scripts[scripts.length - 1];
	  }
	}
	
	function dateToUnix(val) {
	  var date = (0, _moment2.default)(val, 'DD.MM.YYYY');
	
	  if (!date.isValid()) {
	    date = (0, _moment2.default)(new Date());
	  }
	
	  return date.toDate().getTime();
	}
	
	function dateFromUnix(val) {
	  return _moment2.default.unix(val).toDate();
	}
	
	function getOrientation(file, callback) {
	  var reader = new FileReader();
	  reader.onload = function (e) {
	    var view = new DataView(e.target.result);
	    if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
	    var length = view.byteLength,
	        offset = 2;
	    while (offset < length) {
	      var marker = view.getUint16(offset, false);
	      offset += 2;
	      if (marker == 0xFFE1) {
	        if (view.getUint32(offset += 2, false) != 0x45786966) return callback(-1);
	        var little = view.getUint16(offset += 6, false) == 0x4949;
	        offset += view.getUint32(offset + 4, little);
	        var tags = view.getUint16(offset, little);
	        offset += 2;
	        for (var i = 0; i < tags; i++) {
	          if (view.getUint16(offset + i * 12, little) == 0x0112) return callback(view.getUint16(offset + i * 12 + 8, little));
	        }
	      } else if ((marker & 0xFF00) != 0xFF00) break;else offset += view.getUint16(offset, false);
	    }
	    return callback(-1);
	  };
	  reader.readAsArrayBuffer(file);
	}
	
	function parseErrorObj(response) {
	  if ((0, _typeof3.default)(response.data) === 'object') {
	    return response.data;
	  } else {
	    var newObj = {};
	    newObj = { code: response.status, errorCode: response.status };
	    newObj.parameters = {};
	    newObj.parameters.errorCode = response.status;
	    return newObj;
	  }
	}
	
	function arrayHasArray(arrayContainer, arrayToFind) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = (0, _getIterator3.default)(arrayContainer), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var array = _step.value;
	
	      var allValuesSame = true;
	      for (var i = array.length - 1; i >= 0; i--) {
	        if (array[i] !== arrayToFind[i]) {
	          allValuesSame = false;
	          break;
	        }
	      }
	      if (allValuesSame) {
	        return true;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return false;
	}
	
	function redirectPost(url, data) {
	  var form = document.createElement('form');
	  document.body.appendChild(form);
	  form.method = 'post';
	  form.action = url;
	
	  (0, _entries2.default)(data).forEach(function (_ref) {
	    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	        key = _ref2[0],
	        value = _ref2[1];
	
	    var input = document.createElement('input');
	    input.type = 'hidden';
	    input.name = key;
	    input.value = value;
	    form.appendChild(input);
	  });
	
	  form.submit();
	}
	
	function validateSSN(ssn, t) {
	  ssn = ssn.replace(/\s/g, '');
	
	  var _kennitala$info = kennitala.info(ssn),
	      valid = _kennitala$info.valid,
	      age = _kennitala$info.age,
	      type = _kennitala$info.type;
	
	  if (!ssn.match(/^\d{6}-?\d{4}$/) || !valid) {
	    return false;
	  }
	
	  if (type === 'person' && age < 18) {
	    return false;
	  }
	
	  return true;
	}
	
	function validateSsnInput(e) {
	  if (isNaN(Number(e.target.value))) {
	    e.target.value = e.target.value.slice(0, e.target.value.length - 1);
	  }
	  if (e.target.value.length > 10) {
	    e.target.value = e.target.value.slice(0, 10);
	  }
	}
	
	function fixMeterDecimals(meter, value) {
	  if (!isNaN(parseFloat(value))) {
	    if (meter.aukastafaFjoldi < 1) {
	      return value;
	    }
	
	    var splits = value.trim().split(',');
	    var digits = splits[0];
	    var decimals = splits[1];
	
	    if (decimals !== undefined) {
	      decimals = decimals.slice(0, meter.aukastafaFjoldi);
	    } else {
	      decimals = '0'.repeat(meter.aukastafaFjoldi);
	    }
	
	    return digits + ',' + decimals;
	  } else {
	    return value;
	  }
	}

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _promise = __webpack_require__(51);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(49);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(22);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(15);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _constants2 = __webpack_require__(5);
	
	var _constants3 = _interopRequireDefault(_constants2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _constants = (0, _constants3.default)(),
	    SERVER_URL = _constants.SERVER_URL,
	    LANGUAGE_CODE = _constants.LANGUAGE_CODE;
	
	(function () {
	    var UNPARSED_ROUTE_REGEX = /\{\w*\}/;
	
	    function generateUrl(route, params) {
	        var url = (0, _keys2.default)(params).reduce(function (url, param) {
	            return url.replace('{' + param + '}', encodeURIComponent(params[param]));
	        }, route);
	
	        if (UNPARSED_ROUTE_REGEX.test(url)) {
	            throw "Unparsed route found in url. Route: " + route + " url after transform: " + url;
	        }
	
	        return url;
	    }
	
	    var routes = {
	        fetchFlutningsMeterData: 'flutningstilkynning/users/{ssn}/utilities/{meter_id}',
	        fetchAlestrarMeterData: 'alestrarform/users/{ssn}/utilities/{meter_id}',
	        checkFlutningsAddress: 'flutningstilkynning/users/{ssn}/address/{address}',
	        addressFlutningsLookup: 'flutningstilkynning/address/lookup/{query}',
	        submitFlutningsRelocation: 'flutningstilkynning/submitRelocation',
	        submitAlestrarReadings: 'alestrarform/submitReadings',
	        registerLyklaUser: 'lyklaform/register',
	        submitContactForm: 'hafasamband',
	        submitNewCustomer: 'hafasamband',
	        fetchAlestrarMeterDataByToken: 'alestrarform/token/{token}',
	        fetchFlutningsMeterDataByToken: 'flutningsform/token/{token}'
	    };
	
	    function fetchFlutningsMeterData(ssn, meterId, date, cb, http) {
	        var url = generateUrl(routes.fetchFlutningsMeterData, {
	            ssn: ssn,
	            meter_id: meterId
	        });
	
	        var data = date ? { date: (0, _moment2.default)(date).format('YYYY-MM-DD') } : null;
	        var options = {
	            'headers': { 'contentType': 'application/json' }
	        };
	
	        http.get(SERVER_URL + '/' + url).then(function (data) {
	            var error = data ? null : new Error('No data returned in a successful request');
	            if (data && data.data && (0, _typeof3.default)(data.data) === 'object') {
	                cb(true, error, data);
	            } else {
	                cb(false, error, data);
	            }
	        }, function (response) {
	            cb(false, response, data);
	        });
	        return true;
	    }
	
	    function fetchAlestrarMeterData(ssn, meterId, date, cb, http) {
	        var url = generateUrl(routes.fetchAlestrarMeterData, {
	            ssn: ssn,
	            meter_id: meterId
	        });
	
	        var data = date ? { date: (0, _moment2.default)(date).format('YYYY-MM-DD') } : null;
	        var options = {
	            'headers': { 'contentType': 'application/json' }
	        };
	
	        http.get(SERVER_URL + '/' + url).then(function (data) {
	            var error = data ? null : new Error('No data returned in a successful request');
	            if (data && data.data && (0, _typeof3.default)(data.data) === 'object') {
	                cb(true, error, data);
	            } else {
	                cb(false, error, data);
	            }
	        }, function (response) {
	            if (response.status === 0) {
	                response.status = 500;
	            }
	
	            cb(false, response, data);
	        });
	        return true;
	    }
	
	    function fetchAlestrarMeterDataByToken(token, date, cb, http) {
	        var url = generateUrl(routes.fetchAlestrarMeterDataByToken, {
	            token: token
	        });
	
	        var data = date ? { date: (0, _moment2.default)(date).format('YYYY-MM-DD') } : null;
	        var options = {
	            'headers': { 'contentType': 'application/json' }
	        };
	
	        http.get(SERVER_URL + '/' + url).then(function (data) {
	            var error = data ? null : new Error('No data returned in a successful request');
	            if (data && data.data && (0, _typeof3.default)(data.data) === 'object') {
	                cb(true, error, data);
	            } else {
	                cb(false, error, data);
	            }
	        }, function (response) {
	            cb(false, response, data);
	        });
	        return true;
	    }
	
	    function fetchFlutningsMeterDataByToken(token, date, cb, http) {
	        var url = generateUrl(routes.fetchFlutningsMeterDataByToken, {
	            token: token
	        });
	
	        var data = date ? { date: (0, _moment2.default)(date).format('YYYY-MM-DD') } : null;
	        var options = {
	            'headers': { 'contentType': 'application/json' }
	        };
	
	        http.get(SERVER_URL + '/' + url).then(function (data) {
	            var error = data ? null : new Error('No data returned in a successful request');
	            if (data && data.data && (0, _typeof3.default)(data.data) === 'object') {
	                cb(true, error, data);
	            } else {
	                cb(false, error, data);
	            }
	        }, function (response) {
	            cb(false, response, data);
	        });
	        return true;
	    }
	
	    function checkFlutningsAddress(ssn, address, cb, http) {
	        var url = generateUrl(routes.checkFlutningsAddress, {
	            ssn: ssn,
	            address: address
	        });
	        var options = {
	            'headers': { 'contentType': 'application/json' }
	        };
	
	        http.get(SERVER_URL + '/' + url).then(function (data) {
	            var error = data ? null : new Error('No data returned in a successful request');
	            cb(true, error, data);
	        }, function (response) {
	            cb(false, response);
	        });
	
	        return true;
	    }
	
	    function addressFlutningsLookup(query, cb, http) {
	        console.log('addressFlutningsLookup query', query);
	        var url = generateUrl(routes.addressFlutningsLookup, {
	            query: query
	        });
	
	        http.get(SERVER_URL + '/' + url).then(function (data) {
	            var error = data ? null : new Error('No data returned in a successful request');
	            console.log('data', data);
	            cb(true, error, data);
	        }, function (response) {
	            console.log('data', data);
	            cb(false, response, data);
	        });
	    }
	
	    function submitFlutningsRelocation(requestParams, cb) {
	        _jquery2.default.ajax({
	            type: 'POST',
	            url: SERVER_URL + '/' + routes.submitFlutningsRelocation,
	
	            data: {
	                json: (0, _stringify2.default)(requestParams)
	            },
	            success: function success(response) {
	                cb(true, { response: response, requestParams: requestParams });
	            },
	            error: function error(response) {
	                cb(false, { response: response, requestParams: requestParams });
	            }
	        });
	    }
	
	    function submitAlestrarReadings(data, cb, http) {
	        _jquery2.default.ajax({
	            type: 'POST',
	            url: SERVER_URL + '/' + routes.submitAlestrarReadings,
	
	            data: {
	                json: (0, _stringify2.default)(data)
	            },
	            success: function success(data) {
	                cb(true);
	            },
	            error: function error(response) {
	                cb(false, response);
	            }
	        });
	    }
	
	    function fetchLanguageFile(cb) {
	        _jquery2.default.ajax({
	            type: 'GET',
	            url: SERVER_URL + '/language/' + LANGUAGE_CODE + '?version=' + (0, _moment2.default)().unix(),
	            dataType: "json",
	
	            success: function success(data) {
	                cb(true, data.errorDetails, data);
	            },
	            error: function error(e) {
	                cb(false);
	            }
	        });
	    }
	
	    function registerLyklaUser(data) {
	        return new _promise2.default(function (resolve, reject) {
	            _jquery2.default.ajax({
	                type: 'POST',
	                url: SERVER_URL + '/' + routes.registerLyklaUser,
	                data: {
	                    json: (0, _stringify2.default)(data)
	                },
	
	                success: function success(data) {
	                    resolve(data);
	                },
	                error: function error(e) {
	                    reject(e);
	                }
	            });
	        });
	    }
	
	    function submitContactForm(data) {
	        return new _promise2.default(function (resolve, reject) {
	            _jquery2.default.ajax({
	                type: 'POST',
	                url: SERVER_URL + '/' + routes.submitContactForm,
	                data: {
	                    json: (0, _stringify2.default)(data)
	                },
	
	                success: function success(data) {
	                    resolve(data);
	                },
	                error: function error(e) {
	                    reject(e);
	                }
	            });
	        });
	    }
	
	    function submitNewCustomer(data) {
	        return new _promise2.default(function (resolve, reject) {
	            _jquery2.default.ajax({
	                type: 'POST',
	                url: SERVER_URL + '/' + routes.submitNewCustomer,
	                data: {
	                    json: (0, _stringify2.default)(data)
	                },
	
	                success: function success(data) {
	                    resolve(data);
	                },
	                error: function error(e) {
	                    reject(e);
	                }
	            });
	        });
	    }
	
	    window.Api = {
	        fetchFlutningsMeterData: fetchFlutningsMeterData,
	        fetchAlestrarMeterData: fetchAlestrarMeterData,
	        fetchAlestrarMeterDataByToken: fetchAlestrarMeterDataByToken,
	        checkFlutningsAddress: checkFlutningsAddress,
	        addressFlutningsLookup: addressFlutningsLookup,
	        submitFlutningsRelocation: submitFlutningsRelocation,
	        submitAlestrarReadings: submitAlestrarReadings,
	        fetchLanguageFile: fetchLanguageFile,
	        registerLyklaUser: registerLyklaUser,
	        submitContactForm: submitContactForm,
	        submitNewCustomer: submitNewCustomer
	    };
	
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Api;
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (Api), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (window) {
	        window.Api = Api;
	    }
	})();

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(2);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function (id) {
	  var currentScript = util.getCurrentScript(id);
	
	  return {
	    SERVER_URL: currentScript && currentScript.getAttribute('data-url') ? currentScript.getAttribute('data-url') : 'http://localhost:8000',
	    ORIGIN_KEY: currentScript && currentScript.getAttribute('data-originkey') ? currentScript.getAttribute('data-originkey') : 'hafasamband',
	    TOKEN_ATTR: currentScript && currentScript.getAttribute('data-token') ? currentScript.getAttribute('data-token') : false,
	    LANGUAGE_CODE: currentScript && currentScript.getAttribute('data-lang') ? currentScript.getAttribute('data-lang') : 'is',
	    STEP4_REDIRECT_URL: currentScript && currentScript.getAttribute('data-redirect') ? currentScript.getAttribute('data-redirect') : '',
	    COOKIE_INFO: currentScript && currentScript.getAttribute('data-cookie') ? currentScript.getAttribute('data-cookie') : '',
	    COOKIE_VERSION: currentScript && currentScript.getAttribute('data-cookieversion') ? currentScript.getAttribute('data-cookieversion') : '0',
	    WEB_COOKIE_PAGE_LINK: currentScript && currentScript.getAttribute('data-cookie-link') ? currentScript.getAttribute('data-cookie-link') : 'https://www.or.is/um-or/skipulag-og-stjornhaettir/stefnuskjol/vafrakokur/',
	    DISPLAY_MODE: currentScript && currentScript.getAttribute('data-displaymode') ? currentScript.getAttribute('data-displaymode') : 'default',
	    ALERTS: {
	      INVALID_FIELDS: 'Einhverjir reitir eru ekki rétt útfylltir \n\n',
	      EMPTY_FIELDS: 'Vantar að fylla út nauðsynlega reiti \n\n',
	      INVALID_RANGE: 'Einn eða fleiri álestrar utan viðmiðunarmarka. Athugið hvort rétt gildi hafi verið slegið inn\n\n',
	      INVALID_DATE: '',
	      INSTRUCTIONS: 'Ýttu á OK til að halda áfram eða Cancel til að hætta við',
	      NO_METERS_SELECTED: 'Engir mælar valdir',
	      INVALID_PAYMENT_INFO: 'Veldu greiðslumáta',
	      INVALID_CREDIT_CARD_INFO: 'Vinsamlegast fylltu út kortaupplýsingar',
	      INVALID_CREDIT_CARD_EXPIRATION_DATE: 'Athugaðu hvort gildistími kreditkorts sé réttur',
	      INVALID_AGE: 'Lágmarksaldur til að taka við mælum er 18 ár'
	    },
	    REPORTER: {
	      'movingout': 0,
	      'movingin': 1,
	      'annar': 2
	    }
	  };
	};

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VEITUKERFI = exports.ALERTS = exports.TYPE_OF_READING = exports.TOOLTIP_MSG = exports.LANGUAGE_STRINGS = exports.CURRENT_LANGUAGE = undefined;
	
	var _util = __webpack_require__(2);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var currentScript = util.getCurrentScript();
	
	var CURRENT_LANGUAGE = exports.CURRENT_LANGUAGE = currentScript && currentScript.getAttribute('data-lang') ? currentScript.getAttribute('data-lang') : 'is';
	
	var LANGUAGE_STRINGS = exports.LANGUAGE_STRINGS = {
	  'is': {
	    BASIC_INFO: 'Grunnupplýsingar',
	    METER_READINGS: 'Álestrar',
	    CONTACT_INFO: 'Samskiptaupplýsingar',
	    SUMMARY_AND_CONFIRMATION: 'Samantekt & staðfesting',
	    REQUEST_READING: 'Óskað eftir álestri',
	
	    FORWARD: 'Áfram',
	    FORWARD_FINISH: 'Senda álestur',
	    BACK: 'Til baka',
	    CHANGE: 'Breyta',
	    SEND: 'Senda',
	    FETCHING_DATA: 'Sæki gögn',
	    SENDING_DATA: 'Sendi gögn',
	
	    METER_OWNER_SSN: 'Sláðu inn kennitölu (án bandstriks) þess sem skráður er fyrir mæli',
	    INPUT_A_METER_NUMBER: 'Sláðu inn allt númer eins rafmagns- eða hitamælis. ATHUGIÐ að slá EKKI inn stöðu mælis hér',
	    SIX_NUMBERS_OR_MORE: '6 tölustafir eða fleiri',
	    METER_INPUT_INFOMSG: 'Þetta mælanúmer er til auðkenningar og til að sýna í næsta skrefi aðra mæla sem skráðir eru á kennitöluna á sama heimilisfangi.',
	    METER_INPUT_ERROR: 'Kennitalan og mælanúmerið passa ekki saman. Prófaðu kennitölu maka. Upplýsingar um álestra og mæla má finna hér: ',
	    METER_INFO_LINK_LABEL: 'Mælar og álestrar',
	    METER_INFO_LINK: '//www.veitur.is/spurningar-og-rad/maelar-og-alestrar',
	
	    REGISTERING_READING: 'Skráir þú álestur?',
	    YES_I_HAVE_REGISTERED_A_READING: 'Já, það er búið að lesa af og ég vill skrá það hér',
	    NO_I_WANT_VEITUR_TO_PERFORM_READING: 'Nei, ég vil að starfsmaður Veitna komi og lesi af',
	    TRANSFER_ADDRESS: 'Heimilisfang notendaskipta',
	    NOTICE_FEE_WILL_BE_CHARGED: 'Athugið að tekið er gjald vegna komu starfsmanns til að lesa af vegna flutninga.',
	    SEE_PRICE_LIST: 'Sjá verðskrá',
	
	    METER_OVERVIEW: 'Yfirlit mæla',
	    METER_OVERVIEW_INSTRUCTIONS: 'Vinsamlegast skráðu inn dagsetningu og stöðu þeirra mæla sem þú vilt skila álestri af',
	    ONE_OR_MORE: 'einn eða fleiri.',
	    METER_NUMBER: 'Mælanúmer',
	    METER_ADDRESS: 'Notkunarstaður',
	    METER_TYPE: 'Veitutegund',
	    METER_IMAGE: 'Mynd af álestri',
	    METER_RETURN: 'Skila álestri',
	    UPLOAD_IMAGE: 'Hlaða upp mynd',
	
	    DATE_OF_LAST_READING: 'Síðasti álestur',
	    DATE_OF_READING: 'Dagsetning álesturs',
	    METER_STATUS: 'Staða mælis',
	    EXTRA_READING: 'Eftirlitsálestur án uppgjörsreiknings',
	    EXTRA_READING_MSG: 'Einungis er hægt að senda inn eftirlitsálestur án uppgjörs',
	    SELECT_METER: 'Velja mæli',
	    ATTENTION: 'Athugið',
	
	    ATTENTION_READING_CANNOT_BE_OLDER_THAN_30_DAYS: 'Ath. álesturinn má ekki vera eldri en 30 daga gamall',
	
	    METER_READING_FREQUENCY_MSG: 'Ekki er hægt að senda inn álestur á sama mæli örar en á 28 daga fresti.',
	    METER_READING_AGE_MSG: 'Álestur má ekki vera eldri en dagsgamall.',
	    METER_READING_EXTRA_READING_MSG: 'Að senda inn eftirlitsálestur hentar einungis þeim sem vilja fylgjast náið með notkun sinn og skrá inn álestra reglulega.',
	
	    EXTRA_READING_WITHOUT_SETTLEMENT: 'Eftirlitsálestur án uppgjörsreiknings:',
	    EXTRA_READING_WITHOUT_SETTLEMENT_MSG: 'Mánaðarlegir reikningar byggja á ætlaðri notkun yfir árið sem er dreift jafnt niður á mánuði. Að senda inn „Eftirlitsálestur án uppgjörsreiknings“ er einungis til þess gert að viðskiptavinir geti fylgst með notkun án þess að fá uppgjör. Notkun getur verið mjög sveiflukennd og mánaðarlegir reikningar því misháir sé óskað eftir uppgjöri í hvert sinn sem lesið er af',
	    EXTRA_READING_WITHOUT_SETTLEMENT_MSG2: 'Þeir sem skrá reglulega eftirlitsálestur fá engu að síður áminningu um árlegan álestur frá okkur vegna uppgjörs. Þá er ekki hægt að skrá eftirlitsálestur.',
	
	    PLEASE_SELECT_METERS_TO_REGISTER: 'Vinsamlegast veldu þá mæla sem þú vilt tilkynna notendaskipti á og sláðu inn stöðu',
	
	    READING_INPUT_ERRORS_MSG: 'Einn eða fleiri álestrar sem þú hefur slegið inn gefa til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. Athugaðu hvort þú hafir slegið inn réttar tölur',
	    CONTINUE_IF_YOU_ARE_SURE: 'Ef þú ert alveg viss getur þú smellt á „Áfram“ og klárað tilkynninguna.',
	
	    I_REQUEST_THAT_VEITUR_PERFORMS_THE_READING: 'Ég óska þess að starfsfólk Veitna komi og lesi af',
	    NAME_THE_ADDDRESS_OR_METER_MSG: 'Tilgreindu þá staði eða mælanúmer sem flutningurinn á við. Dæmi: Íbúð 201 eða bílskúr nr. 2.',
	    IN_THE_NEXT_STEP_MSG: 'Í næsta skrefi skráir þú upplýsingar um þann sem flytur inn.',
	
	    YOUR_NAME: 'Nafnið þitt',
	    YOUR_EMAIL: 'Netfangið þitt',
	    YOUR_PHONE_NUMBER: 'Símanúmerið þitt',
	
	    THE_ONE_MOVING_OUT: 'Sá sem flytur út:',
	    THE_ONE_MOVING_IN: 'Sá sem tekur við:',
	    OTHER: 'Annar',
	
	    SSN_OF_THE_ONE_WHO_TAKES_OVER_THE_METERS: 'Kennitala þess sem tekur við mælum',
	    YOUR_SSN: 'Kennitalan þín',
	    MAILING_ADDRESS: 'Heimilisfang þar sem póstur á að berast',
	    POSTAL_CODE_PLACE: 'Póstnúmer / Staður',
	    OK: 'OK',
	
	    METHOD_OF_PAYMENT: 'Greiðslumáti',
	    NET_PAYMENT: 'Netgreiðslur (kröfur birtast eingöngu í heimabanka)',
	    DEPOSIT_SLIP: 'Greiðsluseðill',
	    DIRECT_PAYMENT: 'Beingreiðslur (þjónusta sem bankar bjóða viðskiptavinum sínum)',
	    CREDIT_CARD: 'Kreditkort',
	
	    CARD_HOLDERS_NAME: 'Nafn korthafa',
	    CARD_NUMBER: 'Kortanúmer',
	    CARD_EXPIRATION_DATE: 'Gildistími (mán / ár)',
	
	    YOU_HAVE_REGISTERED_THE_FOLLOWING_METERS: 'Þú hefur skráð upplýsingar um stöðu eftirtaldra mæla',
	    TYPE_OF_READING_LABEL: 'Tegund álestrar',
	    OTHER_INFO: 'Aðrar upplýsingar:',
	    WHO_IS_REPORTING: 'Sá sem tilkynnir',
	    READING_HISTORY: 'Álestrarsaga',
	    READING_HISTORY_MSG: 'Þú getur fengið yfirlit yfir álestra á þínum mælum hér á',
	    MY_PAGES: 'Mínum síðum',
	    SUBMIT_FAILED: 'Því miður tókst ekki að senda inn álestur',
	    SUBMIT_RECEIVED: 'Álestur móttekinn',
	    YOU_HAVE_REQUESTED_A_READING_FROM_VEITUR: 'Þú hefur óskað eftir að starfsmaður komi og lesi af',
	    DATE: 'Dagsetning',
	
	    SSN: 'Kennitala',
	    NAME: 'Nafn',
	    EMAIL_ADDRESS: 'Netfang',
	    PHONE_NUMBER: 'Símanúmer',
	    ADDRESS: 'Heimilisfang',
	
	    TRANSFER_REQUEST_RECEIVED: 'Flutningstilkynning móttekinn',
	    COMMENTS: 'Athugasemdir',
	
	    ALERTS: {
	      'INVALID_FIELDS': 'Einhverjir reitir eru ekki rétt útfylltir \n\n',
	      'EMPTY_FIELDS': 'Vantar að fylla út nauðsynlega reiti \n\n',
	      'INVALID_RANGE': 'Einn eða fleiri álestrar utan viðmiðunarmarka. Athugið hvort rétt gildi hafi verið slegið inn\n\n',
	      'INVALID_DATE': '',
	      'INSTRUCTIONS': 'Ýttu á OK til að halda áfram eða Cancel til að hætta við',
	      'NO_METERS_SELECTED': 'Engir mælar valdir',
	      'INVALID_PAYMENT_INFO': 'Veldu greiðslumáta',
	      'INVALID_CREDIT_CARD_INFO': 'Vinsamlegast fylltu út kortaupplýsingar',
	      'INVALID_CREDIT_CARD_EXPIRATION_DATE': 'Athugaðu hvort gildistími kreditkorts sé réttur',
	      'INVALID_AGE': 'Lágmarksaldur til að taka við mælum er 18 ár',
	      'INVALID_ALESTUR': 'Einn eða fleiri álestrar sem þú hefur slegið inn gefa til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. Athugaðu hvort þú hafir slegið inn réttar tölur.\n \n Ef þú ert alveg viss getur þú smellt á „Áfram“ og klárað tilkynninguna.',
	      'SELECT_AT_LEAST_ONE': 'Veldu a.m.k. einn mæli'
	    },
	
	    TOOLTIP_MSG: {
	      'oneDecimal': 'einum aukastaf',
	      'decimals': ' aukastöfum',
	      'inputReadingWith': 'Sláðu álesturinn inn með ',
	      'inputWithOutDecimals': 'Sláðu álesturinn inn án aukastafa (enga kommu).',
	      'readingOutOfRange': 'Þessi álestur gefur til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. ',
	      'checkIfCorrectInput': 'Athugaðu hvort þú hafir slegið inn réttar tölur.'
	    },
	
	    TYPE_OF_READING: {
	      'extraReading': 'Eftirlitsálestur',
	      'settelmentReading': 'Uppgjör'
	    },
	
	    VEITUKERFI: {
	      'R': 'Rafmagn',
	      'H': 'Hiti',
	      'K': 'Kalt vatn'
	    }
	  }
	};
	
	var TOOLTIP_MSG = exports.TOOLTIP_MSG = {
	  'is': {
	    oneDecimal: 'einum aukastaf',
	    decimals: ' aukastöfum',
	    inputReadingWith: 'Sláðu álesturinn inn með ',
	    inputWithOutDecimals: 'Sláðu álesturinn inn án aukastafa (enga kommu).',
	    readingOutOfRange: 'Þessi álestur gefur til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. ',
	    checkIfCorrectInput: 'Athugaðu hvort þú hafir slegið inn réttar tölur.'
	  }
	};
	
	var TYPE_OF_READING = exports.TYPE_OF_READING = {
	  'is': {
	    extraReading: 'Eftirlitsálestur',
	    settelmentReading: 'Uppgjör'
	  }
	};
	
	var ALERTS = exports.ALERTS = {
	  'is': {
	    INVALID_FIELDS: 'Einhverjir reitir eru ekki rétt útfylltir \n\n',
	    EMPTY_FIELDS: 'Vantar að fylla út nauðsynlega reiti \n\n',
	    INVALID_RANGE: 'Einn eða fleiri álestrar utan viðmiðunarmarka. Athugið hvort rétt gildi hafi verið slegið inn\n\n',
	    INVALID_DATE: '',
	    INSTRUCTIONS: 'Ýttu á OK til að halda áfram eða Cancel til að hætta við',
	    NO_METERS_SELECTED: 'Engir mælar valdir',
	    INVALID_PAYMENT_INFO: 'Veldu greiðslumáta',
	    INVALID_CREDIT_CARD_INFO: 'Vinsamlegast fylltu út kortaupplýsingar',
	    INVALID_CREDIT_CARD_EXPIRATION_DATE: 'Athugaðu hvort gildistími kreditkorts sé réttur',
	    INVALID_AGE: 'Lágmarksaldur til að taka við mælum er 18 ár',
	    INVALID_ALESTUR: 'Einn eða fleiri álestrar sem þú hefur slegið inn gefa til kynna mun minni eða meiri notkun en áætlun gerir ráð fyrir. Athugaðu hvort þú hafir slegið inn réttar tölur.\n \n Ef þú ert alveg viss getur þú smellt á „Áfram“ og klárað tilkynninguna.',
	    SELECT_AT_LEAST_ONE: 'Veldu a.m.k. einn mæli'
	  }
	};
	
	var VEITUKERFI = exports.VEITUKERFI = {
	  'is': {
	    'R': 'Rafmagn',
	    'H': 'Hiti',
	    'K': 'Kalt vatn'
	  }
	};

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en-gb": 16,
		"./en-gb.js": 16,
		"./is": 17,
		"./is.js": 17,
		"./pl": 18,
		"./pl.js": 18
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 56;


/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    toggleSettings: function toggleSettings() {
	      this.$dispatch('toggleSettings');
	    },
	    approve: function approve() {
	      this.$dispatch('agree');
	    },
	    saveSettings: function saveSettings() {
	      this.$dispatch('saveSettings');
	    }
	  }
	};

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(47);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(57);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _cookieApp = __webpack_require__(237);
	
	var _cookieApp2 = _interopRequireDefault(_cookieApp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	exports.default = function () {
	  window.orCookieApp = new _vue2.default({
	    el: '#form-client-cookies',
	    components: { cookieapp: _cookieApp2.default },
	    template: '<cookieapp/>',
	    methods: {
	      showapp: function showapp() {
	        this.$broadcast('show-app');
	      }
	    }
	  });
	};

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cookieShared = __webpack_require__(86);
	
	var _cookieShared2 = _interopRequireDefault(_cookieShared);
	
	var _constants2 = __webpack_require__(5);
	
	var _constants3 = _interopRequireDefault(_constants2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _constants = (0, _constants3.default)(),
	    WEB_COOKIE_PAGE_LINK = _constants.WEB_COOKIE_PAGE_LINK;
	
	exports.default = {
	  name: 'cookie-banner',
	
	  mixins: [_cookieShared2.default],
	
	  data: function data() {
	    return {
	      tstrings: {},
	      tstringsReady: false,
	      cookieLink: WEB_COOKIE_PAGE_LINK
	    };
	  },
	
	
	  events: {
	    'language-set': function languageSet(obj) {
	      this.tstrings = obj;
	      this.tstringsReady = true;
	    }
	  }
	};

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['data', 'index', 'tstrings'],
	
	  data: function data() {
	    return {
	      isSelected: false
	    };
	  },
	
	
	  computed: {
	    languageString: function languageString() {
	      if (this.tstrings) {
	        return this.tstrings;
	      }
	    }
	  },
	
	  events: {
	    'selectedIndex': function selectedIndex(_selectedIndex) {
	      this.isSelected = false;
	    }
	  },
	
	  methods: {
	    selectItem: function selectItem() {
	      if (!this.isSelected) {
	        this.$dispatch('content-visible', this.index);
	      }
	      this.isSelected = !this.isSelected;
	    }
	  }
	};

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cookieShared = __webpack_require__(86);
	
	var _cookieShared2 = _interopRequireDefault(_cookieShared);
	
	var _cookieItem = __webpack_require__(235);
	
	var _cookieItem2 = _interopRequireDefault(_cookieItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'cookie-settings',
	  props: ['data'],
	  mixins: [_cookieShared2.default],
	
	  data: function data() {
	    return {
	      tstrings: {},
	      tstringsReady: false
	    };
	  },
	
	
	  components: {
	    cookieitem: _cookieItem2.default
	  },
	
	  events: {
	    'content-visible': function contentVisible(index) {
	      this.$broadcast('selectedIndex', index);
	    },
	    'language-set': function languageSet(obj) {
	      this.tstrings = obj;
	      this.tstringsReady = true;
	    }
	  }
	};

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cookieBanner = __webpack_require__(234);
	
	var _cookieBanner2 = _interopRequireDefault(_cookieBanner);
	
	var _cookieSettings = __webpack_require__(236);
	
	var _cookieSettings2 = _interopRequireDefault(_cookieSettings);
	
	var _cookieShared = __webpack_require__(86);
	
	var _cookieShared2 = _interopRequireDefault(_cookieShared);
	
	var _api = __webpack_require__(3);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _translations = __webpack_require__(20);
	
	var _constants2 = __webpack_require__(5);
	
	var _constants3 = _interopRequireDefault(_constants2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _constants = (0, _constants3.default)(),
	    COOKIE_INFO = _constants.COOKIE_INFO,
	    COOKIE_VERSION = _constants.COOKIE_VERSION;
	
	exports.default = {
	  mixins: [_cookieShared2.default],
	
	  components: {
	    cookiebanner: _cookieBanner2.default,
	    cookiesettings: _cookieSettings2.default
	  },
	
	  data: function data() {
	    return {
	      cookieName: 'or-cookieT',
	      showSettings: false,
	      showCookieApp: true,
	      settingsCookie: '',
	      version: 0,
	      data: {},
	      items: {},
	      cookiePageLink: ''
	    };
	  },
	  ready: function ready() {
	    this.settingsCookie = this.getPreviousSettings(this.cookieName);
	    _api2.default.fetchLanguageFile(this.onLanguageLoaded);
	    this.fetchEmbeddedCookieInfo();
	  },
	
	
	  events: {
	    'toggleSettings': function toggleSettings() {
	      this.showSettings = !this.showSettings;
	    },
	    'saveSettings': function saveSettings() {
	      this.settingsCookie = this.createSettingsCookieString(this.items);
	      this.closeAndSave(this.links);
	    },
	    'agree': function agree() {
	      this.settingsCookie = this.createSettingsCookieString(this.items, true);
	
	      this.closeAndSave(this.items);
	    },
	    'show-app': function showApp() {
	      this.showSettings = !this.showCookieApp;
	      this.showCookieApp = !this.showCookieApp;
	    }
	  },
	
	  computed: {
	    links: function links() {
	      return this.items.filter(function (item) {
	        return item.value === true;
	      });
	    }
	  },
	
	  methods: {
	    fetchEmbeddedCookieInfo: function fetchEmbeddedCookieInfo() {
	      if (COOKIE_INFO) {
	        this.data = JSON.parse(COOKIE_INFO);
	        var version = COOKIE_VERSION;
	
	        if (!this.settingsCookie) {
	          this.items = this.createItems(this.data);
	        } else if (this.settingsCookie) {
	          this.cookieVersion = this.checkCookieVersion(this.settingsCookie);
	          this.items = this.createItemsWithSettings(this.settingsCookie, this.data);
	          this.initializeCookies(this.links);
	          this.showCookieApp = version !== this.checkCookieVersion(this.settingsCookie);
	        }
	      }
	    },
	    onLanguageLoaded: function onLanguageLoaded(loaded, errorDetails, data) {
	      if (loaded) {
	        this.languageObj = data[0];
	      } else {
	        this.languageObj = _translations.LANGUAGE_STRINGS[_translations.CURRENT_LANGUAGE];
	      }
	      this.$broadcast('language-set', this.languageObj);
	    },
	    closeAndSave: function closeAndSave(links) {
	      this.settingsCookie = this.addVersionToCookie(this.settingsCookie, COOKIE_VERSION);
	      this.setCookie(this.cookieName, this.settingsCookie, 1095);
	      this.initializeCookies(links);
	      this.showSettings = false;
	      this.showCookieApp = false;
	    },
	    checkCookieVersion: function checkCookieVersion(cookie) {
	      var arr = cookie.split(',');
	      var version = arr[arr.length - 1].split(':')[1];
	      return version;
	    },
	    createItems: function createItems(data) {
	      var items = [];
	
	      for (var property in data) {
	        var obj = { 'name': property, 'value': property === 'required', 'required': data[property].required, 'links': data[property].links };
	        items.push(obj);
	      }
	
	      return items;
	    },
	    createItemsWithSettings: function createItemsWithSettings(settings, data) {
	      var items = [];
	      var settingsArr = settings.split(',');
	      var settingsObj = {};
	
	      settingsArr.forEach(function (element) {
	        var elementArr = element.split(':');
	        settingsObj[[elementArr[0]]] = elementArr[1];
	      });
	
	      for (var property in data) {
	        var value = settingsObj[property] ? settingsObj[property] === 'true' : false;
	        var obj = { 'name': property, 'value': value, 'required': data[property].required, 'links': data[property].links };
	        items.push(obj);
	      }
	
	      return items;
	    },
	    getPreviousSettings: function getPreviousSettings(cookieName) {
	      var prevCookie = this.getCookie(cookieName);
	      if (prevCookie) {
	        return prevCookie;
	      } else {
	        return false;
	      }
	    },
	    initializeCookies: function initializeCookies(data) {
	      this.clearCookieScripts();
	      var that = this;
	
	      data.forEach(function (linkList) {
	        if (linkList.links) {
	          linkList.links.forEach(function (link) {
	            that.createLink(link);
	          });
	        }
	      });
	    },
	    createLink: function createLink(link) {
	      var linkEl = document.createElement('script');
	      linkEl.setAttribute('src', link);
	      linkEl.className = 'or-cookie-script';
	      document.head.appendChild(linkEl);
	    },
	    clearCookieScripts: function clearCookieScripts() {
	      var cookieScripts = document.querySelectorAll('.or-cookie-script');
	
	      for (var i = 0; i < cookieScripts.length; i++) {
	        cookieScripts[i].remove();
	      }
	    },
	    createSettingsCookieString: function createSettingsCookieString(data, agreeToAll) {
	      var str = '';
	
	      data.forEach(function (element) {
	        var settingsValue = agreeToAll === true ? true : element.value;
	        str += element.name + ':' + settingsValue + ',';
	      });
	
	      str = str.slice(0, -1);
	      return str;
	    },
	    addVersionToCookie: function addVersionToCookie(cookie, version) {
	      var cookieArr = cookie.split(',');
	      if (cookieArr[cookieArr.length - 1].split(':')[0] === 'ver') {
	        cookieArr.pop();
	      }
	      return cookieArr.join() + ',ver:' + version;
	    },
	    setCookie: function setCookie(cname, cvalue, exdays) {
	      var d = new Date();
	      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	      var expires = 'expires=' + d.toUTCString();
	      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	    },
	    getCookie: function getCookie(cname) {
	      var name = cname + '=';
	      var decodedCookie = decodeURIComponent(document.cookie);
	      var ca = decodedCookie.split(';');
	
	      for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	          c = c.substring(1);
	        }
	        if (c.indexOf(name) === 0) {
	          return c.substring(name.length, c.length);
	        }
	      }
	      return '';
	    }
	  }
	};

/***/ }),

/***/ 229:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 230:
/***/ (function(module, exports) {

	module.exports = " <div> <div class=or-cookie__banner v-if=tstringsReady> <div class=or-cookie__text>{{tstrings.KOKUAPP.COOKIE_MSG}} <a :href=cookieLink>{{tstrings.KOKUAPP.COOKIE_PAGE_LINK_TEXT}}</a></div> <div class=or-cookie__buttons> <button class=or-cookie__button v-on:click=approve>{{tstrings.KOKUAPP.AGREE}}</button> <button class=or-cookie__button v-on:click=toggleSettings>{{tstrings.KOKUAPP.COOKIE_SETTINGS}}</button> </div> </div> </div> ";

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	module.exports = " <div class=or-cookie__item v-bind:class=\"{'or-cookie__item--selected': isSelected}\"> <div class=or-cookie__item-header> <h1 v-on:click=selectItem>{{languageString.KOKUAPP[data.name].title}}</h1> <div class=or-cookie__toggle v-if=\"isSelected && data.links.length > 0\" v-bind:class=\"{'or-cookie__toggle--disabled' : data.required}\"> <input type=checkbox v-model=data.value true-value=yes false-value=no id=check-{{index}} :disabled=data.required> <label for=check-{{index}}>{{data.value ? languageString.KOKUAPP.ENABLED : languageString.KOKUAPP.DISABLED}}</label> </div> </div> <div class=or-cookie__item-content v-show=isSelected> <p v-html=\"languageString.KOKUAPP[data.name].text \"></p> </div> </div> ";

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

	module.exports = " <div class=or-cookie__bg> <div class=or-cookie__settings v-if=tstringsReady> <div class=or-cookie__close v-on:click=toggleSettings>{{tstrings.KOKUAPP.CLOSE}}</div> <h1>{{tstrings.KOKUAPP.CENTER_FOR_PRIVACY}}</h1> <div class=or-cookie__items> <cookieitem v-for=\"(index, item) in data\" :data.sync=item :index=index :tstrings.sync=tstrings></cookieitem> </div> <button class=or-cookie__save v-on:click=saveSettings>{{tstrings.KOKUAPP.SAVE_SETTINGS}}</button> </div> </div> ";

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	module.exports = " <div id=cookieapp class=or-cookie v-show=showCookieApp role=form aria-label=\"Cookie consent\"> <cookiebanner v-show=!showSettings></cookiebanner> <cookiesettings v-show=showSettings :data.sync=items></cookiesettings> </div> ";

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(183)
	__vue_template__ = __webpack_require__(230)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(184)
	__vue_template__ = __webpack_require__(231)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(185)
	__vue_template__ = __webpack_require__(232)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(229)
	__vue_script__ = __webpack_require__(186)
	__vue_template__ = __webpack_require__(233)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _kokuappSharedInstance = __webpack_require__(182);
	
	var _kokuappSharedInstance2 = _interopRequireDefault(_kokuappSharedInstance);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.addEventListener('load', function () {
	  (0, _kokuappSharedInstance2.default)();
	});

/***/ })

});


// WEBPACK FOOTER //
// dist/js/kokuapp_onload.js